import 'promise-polyfill/src/polyfill';
import '@p/polyfill';
import './$';
import { proverka } from '@p/proverka';
import { theme } from "./theme";
import transitions from "./fadeV2";
import main from "./main";
// import serviceWorker from "@p/service-worker";
import intersectionObserver from "./intersectionObserver";
import { preloaderStart, scrollToBlock, soundManager } from './animation';
if ($('.hamburger')) $('.hamburger').onclick = function (e) {
  if (!$('.hamburger').classList.contains('open')) {
    $('.hamburger').classList.add('open');
    $('.menu').classList.add('active');
    soundPush('/sound/ps5/ps5-popup-2.mp3');
  } else {
    $('.menu').classList.remove('active');
    $('.hamburger').classList.remove('open');
    soundPush('/sound/ps5/ps5-popup-2.mp3');
  }
};
if ($('[data-disable-mouse2]')) $('body').addEventListener('contextmenu', function (e) {
  e.preventDefault();
  cPush.show({
    text: "\u0412 \u0446\u0435\u043B\u044F\u0445 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043C\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u043D\u043E\u0435 \u043C\u0435\u043D\u044E \u043D\u0430 \u043D\u0430\u0448\u0435\u043C \u0441\u0430\u0439\u0442\u0435!"
  });
});
$$('.menu__item').forEach(function (elem) {
  elem.addEventListener('click', function () {
    return $(".menu").classList.remove("active");
  });
});
if ($(".chose__call")) $(".chose__call").onclick = function (e) {
  malert.show({
    title: "\u0413\u0434\u0435 \u0443\u0434\u043E\u0431\u043D\u043E \u043F\u043E\u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F?",
    whatsapp: true,
    //callback: true,
    telega: true,
    // zayavkaBtm: true,
    chatBtm: true
    //  img: `img/icons/help.svg`,
  });
};
if ($(".header__contact__call")) $(".header__contact__call").onclick = function (e) {
  e.preventDefault();
  malert.show({
    title: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u0441\u0432\u044F\u0437\u0438",
    whatsapp: true,
    callback: true,
    telega: true
    // zayavkaBtm: true,
    // chatBtm: true,
    //  img: `img/icons/help.svg`,
  });
};
window.addEventListener('scroll', function (e) {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > window.innerHeight) {
    $(".top").classList.add("active");
    $(".top").onclick = function () {
      document.body.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };
  } else {
    $(".top").classList.remove("active");
  }
});
proverka();
main();
transitions();
theme();
intersectionObserver();

//animations
preloaderStart();
scrollToBlock();
soundManager();
cutText('.review__item__text', 80);

// if(!window.location.href.includes('http://localhost:3000')) serviceWorker()

// let loaded = false
// async function startAPP() {
//   if(loaded == true) return
//   // if(window.ym === undefined && !window.location.href.includes('http://localhost:3000')) metrika(), serviceWorker()
//   loaded = true
// }

// setTimeout(() => startAPP(), 3000);
// document.addEventListener('scroll', e=> startAPP(), { once:true})
// document.addEventListener('mouseover', e=> startAPP(), { once:true})
// document.addEventListener('touchstart', e=>startAPP(), { once:true})

///////////////////////END/////////////////////////////